module.exports = __webpack_public_path__ + "static/img/mogos_phone_en.4db8af8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/store/mogos_phone_en.png
// module id = 146
// module chunks = 0